import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    constructor(
        private router: Router,
        private platformLocation: PlatformLocation
    ) {}

    buildNavigateToDetailsUrl(transportOrderNumber: number): string {
        const basePath = this.platformLocation.getBaseHrefFromDOM();

        const url = this.router.serializeUrl(
            this.router.createUrlTree([`${basePath}order-details/${transportOrderNumber}`])
        );

        return url;
    };
}